{
  "Accessibility Menu": "Meni dostopnosti",
  "Reset settings": "Ponastavi nastavitve",
  "Close": "Zapri",
  "Content Adjustments": "Prilagoditve vsebine",
  "Adjust Font Size": "Prilagodi velikost pisave",
  "Highlight Title": "Označi naslov",
  "Highlight Links": "Označi povezave",
  "Readable Font": "Bralna pisava",
  "Color Adjustments": "Prilagoditve barv",
  "Dark Contrast": "Temni kontrast",
  "Light Contrast": "Svetli kontrast",
  "High Contrast": "Visoki kontrast",
  "High Saturation": "Visoka nasičenost",
  "Low Saturation": "Nizka nasičenost",
  "Monochrome": "Monokromno",
  "Tools": "Orodja",
  "Reading Guide": "Bralni vodnik",
  "Stop Animations": "Ustavi animacije",
  "Big Cursor": "Velik kazalec",
  "Increase Font Size": "Povečaj velikost pisave",
  "Decrease Font Size": "Zmanjšaj velikost pisave",
  "Letter Spacing": "Razmik med črkami",
  "Line Height": "Višina vrstice",
  "Font Weight": "Debelina pisave",
  "Dyslexia Font": "Pisava za disleksijo",
  "Language": "Jezik",
  "Open Accessibility Menu": "Odpri meni dostopnosti"
}